/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_LinkInputs */



/**
* | output |
* | --- |
* | "Link" |
*
* @param {Profile_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_link = /** @type {((inputs?: Profile_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincular")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega")
	return /** @type {LocalizedString} */ ("Link")
});